export default "__VITE_ASSET__f5f6e6f0__"